import {Component, Input, OnInit, Renderer2} from '@angular/core';
import * as globals from "../settings";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SubscriptionsService} from "../_services/subscriptions.service";
import {LotteriesService} from "../lotteries.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {JsontranslateService} from "../_services/jsontranslate.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ActionService} from "../_services/action.service";
import {UserService} from "../_services/user.service";
import {GetPaymentMethodsService} from "../shared/paymentMethod/get-payment-methods.service";
import {BonusService} from "../_services/bonus.service";
import {isArray} from "rxjs/util/isArray";
import {CurrencyService} from "../_services/currency.service";
import {CookieService} from "ngx-cookie-service";
import {LoginService} from "../shared/navigation/login.service";
import {GameLauncherService} from "../_services/game-launcher.service";

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss']
})
export class OtpVerifyComponent implements OnInit {

  otp: FormControl
  otpForm: FormGroup
  confStat: string
  otpValueFromInput: string
  otpInvalid: boolean
  close: boolean
  buttonType: string;
  isLoadingButton: boolean;
  goTo: string;
  holdButtonDisabled: boolean;
  languagePage: string;
  fakeCart: boolean; /* we use that for games */
  userDataNameWithGender: any;
  cartItems: number;
  subscription: Subscription;
  brand = globals.brand;
  registerContainerScrollTop: number;
  letsGo: boolean;
  checkIfInCart: boolean;
  checkIfInCartOpenSubscription: Subscription;
  bonusDetails: any;
  registerSubscription: Subscription;
  showOnlyPM: boolean;
  userDetails: any;
  countryForPayments: any;
  currentMethod: string;
  preselectedCurrency: any;
  changedCurrency: Subscription;
  getAvailablePaymentOptions: any;
  loggedStatus: Subscription;
  paystackFlow: boolean;
  gapo: any;
  lastType: number;
  greenSpinner: boolean
  @Input() otpAction: string

  constructor(public subscriptionsService: SubscriptionsService,
              private renderer: Renderer2,
              public lotteryService: LotteriesService,
              private translate: TranslateService,
              private jsontranslate: JsontranslateService,
              private activatedRoute: ActivatedRoute,
              public actionService: ActionService,
              private userService: UserService,
              public getpmService: GetPaymentMethodsService,
              private router: Router,
              public bonusService: BonusService,
              public currencyService: CurrencyService,
              private cookieService: CookieService,
              private loginService: LoginService,
              public gameLauncher: GameLauncherService) {
    this.freshStart()
    this.fakeCart = false;
    this.showOnlyPM = false;
    this.paystackFlow = false;

    this.subscriptionsService.getFakeCart().subscribe(fc => {
      this.fakeCart = fc;
    });
    this.subscription = this.subscriptionsService.getCartItems().subscribe(cartLength => {
      this.cartItems = cartLength;
    });
    this.checkIfInCartOpenSubscription = this.subscriptionsService.getIfInCart().subscribe(checkIfInCart => {
      this.checkIfInCart = checkIfInCart;
    });
    this.registerSubscription = this.subscriptionsService.getRegister().subscribe(register => {
      this.openReg(register).then((resolve) => {
        if (resolve === 'registration') {
          this.showOnlyAddPm();
        }
      });
      if (!register) {
        this.freshStart();
      }
    });

    this.preselectedCurrency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.preselectedCurrency = currency;
      }
    });

    this.loggedStatus = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
      if (!this.getAvailablePaymentOptions) {
        this.getAvaliblePaymentMethods();
      }
    });
  }

  ngOnInit() {
    this.otp = new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(4),
      Validators.pattern('[0-9]+')
    ]);

    this.otpForm = new FormGroup({
      otp: this.otp
    });
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.languagePage = this.translate.currentLang;
      this.jsontranslate.loadTranslations('OtpVerifyComponent', this.translate.currentLang);
    });
  }

  freshStart() {
    this.buttonType = 'button'
    // this.buttonType = 'submit';
    this.goTo = 'startFlow'
    this.letsGo = false;
    this.isLoadingButton = false
    this.holdButtonDisabled = true;
    this.checkIfInCart = false;
    this.otpInvalid = false
    this.greenSpinner = false
  }

  closeOtpVerify() {
    this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
    this.close = true;
    setTimeout(() => {
      this.renderer.removeClass(document.body, 'modal-open-register');
      this.subscriptionsService.emitOtpVerify();
      this.subscriptionsService.emitToggleContent(true);
      this.subscriptionsService.emitFakeCart(false);
    }, 100);
    setTimeout(() => {
      this.freshStart();
    }, 1500);
  }

  verifyOtp() {
    this.isLoadingButton = true;

    let urlParams = {};
    const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
    if (cookieIncentiveCodeExists) {
      urlParams['cookieValue'] = this.cookieService.get('incentiveCode');
    }

    let urlParamString = '?' + this.lotteryService.toSendNoEmail(urlParams);

    const post = {
      code: this.otp.value,
      actionType: this.otpAction
    }

    this.lotteryService.postData(globals.appDomain + '/user/verifyOtp/response.json' + urlParamString,
      this.loginService.getFormUrlEncoded(post))
      .subscribe(
        response => {
          if (response && response.message && response.message.SessionID && response.message.OtpVerifiedStatus) {
            if (this.otpAction === 'register') {
              const loggedInUser = response.message;
              loggedInUser.sessionId = response.message.SessionID;
              loggedInUser.memberId = response.message.MemberID;
              localStorage.setItem('playerDetails', JSON.stringify(loggedInUser));
              sessionStorage.setItem('registed', 'true');
              const userData = response.message;
              localStorage.setItem('playerDetails', JSON.stringify(userData));
              this.subscriptionsService.emitFireRegisterPixel(true);
              if (!this.fakeCart) {
                this.subscriptionsService.emitUserAfterRegistration(userData);
                this.subscriptionsService.emitNewUser(true);
              } else {
                this.userDataNameWithGender = {
                  FirstName: userData.FirstName,
                  LastName: userData.LastName,
                  Gender: userData.Gender,
                };
                this.subscriptionsService.updateUserDataNameWithGender(this.userDataNameWithGender);
                this.subscriptionsService.updateBalance(userData.TotalBalance);
              }
              if (this.cartItems === 0 && !this.fakeCart) {
                this.closeRegistration();
                this.activatedRoute.queryParams.subscribe(params => {
                  this.actionService.goToAction(params, this.languagePage, true);
                });
              } else {
                this.userService.step3 = true;
                this.confStat = 'start';
                this.isLoadingButton = false;
                this.registerContainerScrollTop = 0;
              }
              localStorage.setItem('knownUser', 'true');
              this.subscriptionsService.emitChangeCurrency(response.message.Currency);
              this.userService.getUser();
              this.getAvaliblePaymentMethods();
              setTimeout(() => {
                this.getpmService.getPaymentMethods();
              }, 100);
              if (window.location.href.indexOf('/casino') > -1) {
                this.subscriptionsService.isFreshRegisteredForFDB = true;
                localStorage.setItem('emitFreshRegisteredInCasino', 'true');
              }
              this.getBonusDetails();
            }
            if (this.otpAction === 'login') {
              this.subscriptionsService.emitFreshLogin(true);
              this.renderer.removeClass(document.body, 'modal-open-login');
              localStorage.removeItem('virtualLogin');
              localStorage.setItem('knownUser', 'true');
              const sendData = {};
              // sendData['timeZone'] = this.timeZone;
              sendData['sessionId'] = response.message.SessionID;
              this.userService.getUserDetails(response.message.SessionID, response.message.MemberID, true).then(resolver => {
                if (resolver === 'user') {
                  this.getpmService.getPaymentMethods();
                  setTimeout(() => {
                    // this.loginForm.reset();
                    this.isLoadingButton = false;
                  }, 1000);
                  const language = localStorage.getItem('pageLanguage');
                  setTimeout(() => {
                    if (this.router.url.includes('/casino') && this.gameLauncher.gameId && this.gameLauncher.minBet) {
                      this.gameLauncher.runGame(this.gameLauncher.gameId, this.gameLauncher.minBet);
                    } else {
                      this.activatedRoute.queryParams.subscribe(params => {
                        this.actionService.goToAction(params, language, true);
                      });
                    }
                  }, 300);
                  this.subscriptionsService.triggerNameMagic(true);
                  setTimeout(() => {
                    this.subscriptionsService.triggerNameMagic(true);
                  }, 1000);
                }
              });
              this.closeLogin();
            }
            localStorage.removeItem('otpRecepientEmail');
          } else {
            this.confStat = 'error';
            this.buttonType = 'button';
            this.goTo = 'tryAgain';
            this.isLoadingButton = false;
            if (response.message.ErrorID !== undefined) {
              this.subscriptionsService.emitJinniError(response.message.ErrorID);
              if (this.otp.invalid) {
                this.buttonType = 'button';
                this.goTo = 'startFlow';
                this.confStat = 'start';
              }
            }
          }
        });

  }

  preventTrigger(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  onScroll(event) {
    event.target.scrollTop = 0;
  }

  refreshGoTo() {
    if (this.confStat === 'error') {
      this.goTo = 'startFlow';
      this.buttonType = 'submit';
    }
  }

  nextStep() {
  }

  closeRegistration() {
    this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
    this.close = true;
    this.letsGo = false;
    setTimeout(() => {
      this.renderer.removeClass(document.body, 'modal-open-register');
      this.subscriptionsService.emitRegister(false);
      const emitFreshRegisteredInCasino = localStorage.getItem('emitFreshRegisteredInCasino');
      if (!emitFreshRegisteredInCasino) {
        this.subscriptionsService.closeModalNow(true);
      }
      this.subscriptionsService.emitToggleContent(true);
      this.subscriptionsService.emitFakeCart(false);
      if (localStorage.getItem('waitingForDone') === 'minicheckout') {
        this.subscriptionsService.updateMiniCheckoutAddPM(false);
        localStorage.removeItem('waitingForDone');
      }
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['action'] === 'deposit') {
          this.actionService.goToAction(params, this.languagePage, true);
          const url: string = this.router.url.substring(0, this.router.url.indexOf('?'));
          this.router.navigateByUrl(url);
        }
      });
      if (this.actionService.redirectAfter) {
        setTimeout(() => {
          this.router.navigateByUrl(this.actionService.redirectAfter);
        }, 1500);
      }
      setTimeout(() => {
        this.subscriptionsService.onlyPmStep(false);
      }, 500);
    }, 100);
    setTimeout(() => {
      this.freshStart();
    }, 1500);

    if (!this.checkIfInCart && !this.router.url.includes('/casino') && !this.subscriptionsService.miniCheckoutEnabled) {
      setTimeout(() => {
        this.subscriptionsService.setIsAddFundsOpen(true);
      }, 500);
    }
    setTimeout(() => {
      this.resetBonusDetails();
    }, 300);
  }

  resetBonusDetails() {
    this.bonusDetails = undefined;
  }

  getBonusDetails() {
    this.bonusService.getBonusDetails().then((resp: any) => {
      if (resp.message.Incentive && resp.message.Incentive.Type) {
        this.bonusDetails = resp.message.Incentive;
      }
    });
  }

  showOnlyAddPm() {
    if (this.showOnlyPM) {
      // this.step = 3;
      this.letsGo = false;
      this.buttonType = 'submit';
      // this.step_1_validated = true;
      // this.step_2_validated = true;
      // this.getAvaliblePaymentMethods();
      // const userData = JSON.parse(localStorage.getItem('playerDetails'));
      // if (/[A-Za-z]+/.test(userData.FirstName) && /[A-Za-z]+/.test(userData.LastName)) {
      //   this.registerForm.controls['nameOnCard'].setValue(userData.FirstName + ' ' + userData.LastName);
      // }
      this.getBonusDetails();
      // } else if (this.showOnlyPM && this.brand === 'winaija') {
      // this.closeRegistration();
      // this.subscriptionsService.emitUserNeedIncreseBalance(-1);
    }
  }

  openReg(open) {
    return new Promise(resolve => {
      if (open === true) {
        // this.step = 1;
        this.close = true;
        this.letsGo = true;
        // this.rebuildForm();
        resolve('registration');
      } else {
        this.letsGo = false;
      }
      // this.autoPickCountry();
    });
  }

  getAvaliblePaymentMethods() {
    if (this.userService.userData) {
      this.userDetails = this.userService.userData;
    } else return
    if (this.userDetails && this.userDetails.CountryCode) {
      this.countryForPayments = this.userDetails.CountryCode;
    } else {
      this.countryForPayments = localStorage.getItem('country');
    }
    this.currentMethod = 'Card';
    const langFromLocal = localStorage.getItem('pageLanguage');
    this.lotteryService
      .postData(globals.appDomain + '/payments/getAvailablePaymentOptions/getAvailablePaymentOptions_freshReg.json',
        'countryCode=' + this.countryForPayments + '&lang=' + langFromLocal + '&currency=' +
        this.preselectedCurrency.Code + '&SessionID=' + this.userDetails.sessionId)
      .subscribe(
        result => {

          // todo: hide standard card option for CM
          result.message = result.message.filter(po => po.paymentMethod !== 'Card');

          this.getAvailablePaymentOptions = result.message;
          if (this.getAvailablePaymentOptions.filter(payMeth => {
            return payMeth.paymentMethod === 'paystack';
          }).length > 0) {
            this.paystackFlow = true;
            localStorage.setItem('paystackFlow', '' + this.paystackFlow);
            this.subscriptionsService.emitRegister(false);
            this.subscriptionsService.emitUserNeedIncreseBalance(-1);
            this.subscriptionsService.emitForceStepTwo(true);
          }

          for (const i in result.message) {
            if (isArray(result.message[i].requiredFields)) {
              result.message[i].requiredFieldsArr = result.message[i].requiredFields;
            } else {
              result.message[i].requiredFieldsArr = [];
              for (const index in result.message[i].requiredFields) {
                if (index !== undefined && result.message[i].requiredFields[index] !== undefined) {
                  result.message[i].requiredFieldsArr.push(result.message[i].requiredFields[index]);
                }
              }
            }
          }

          this.gapo = result.message;
        }
      );
    this.close = true;
  }

  checkOtpCharLength(e) {
    this.otp.value
    && this.otp.value.toString().length === 4
    && !this.isBackspace(e.keyCode)
      ? e.preventDefault()
      : null
  }

  toggleBtnAvailability() {
    if (this.otp.value && this.otp.value.toString().length === 4) {
      this.buttonType = 'submit'
      this.holdButtonDisabled = false
    } else {
      this.buttonType = 'button'
      this.holdButtonDisabled = true
    }
  }

  isBackspace(kc) {
    return kc === 8
  }

  resendCode(e) {
    this.greenSpinner = true

    const otpRecipientEmail = localStorage.getItem('otpRecepientEmail')
    if (!otpRecipientEmail.length) return

    this.lotteryService
      .postData(globals.appDomain + '/user/resendOtp/response.json', 'email=' + otpRecipientEmail)
      .subscribe(
        result => {

          if (result.message.OtpCodeSent == true) {
            this.greenSpinner = false
            const viewportOffset = e.srcElement.getBoundingClientRect();
            const top = viewportOffset.top + (viewportOffset.height / 2);
            const left = viewportOffset.left + viewportOffset.width + 9;
            const tooltipConfig = {
              top: top,
              left: left,
              show: true,
              message: 'Code sent!',
              cssClass: 'green'
            }
            this.subscriptionsService.emitJinniTooltip(tooltipConfig);
          }

        }
      );

  }

  closeLogin() {
    this.isLoadingButton = false;
    this.subscriptionsService.emitToggleContent(true);
    this.subscriptionsService.closeModalNow(true);
    this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
    this.renderer.removeClass(document.body, 'modal-open-login');
    setTimeout(() => {
      this.renderer.removeClass(document.body, 'modal-open-register');
      this.subscriptionsService.emitLogin(false);
    }, 1000);
  }

}
